<script lang="ts">
  import { Button, Dialog } from "@tastyworks/ui-library"

  interface Props {
    onAllow: () => void
    onDeny: () => void
  }

  let { onAllow, onDeny }: Props = $props()

  let open = $state(true)
</script>

<Dialog.Root bind:open>
  <Dialog.Portal>
    <Dialog.Overlay />
    <Dialog.Content disableEscKey disableClickOutside>
      <Dialog.Title>Screen Sharing Request</Dialog.Title>
      <Dialog.Description>
        <p>
          Your support agent is requesting to view this page. This session will
          be recorded for quality and training purposes. By clicking "Allow,"
          you consent to screen sharing and recording for the duration of this
          session.
        </p>
        <p class="mt-3">
          You agree that it is your responsibility, and not tastytrade's, to
          minimize or otherwise obscure any other pages you do not wish to share
          with tastytrade. You can stop sharing at any time.
        </p>
      </Dialog.Description>
      <Dialog.Actions>
        <Button variant="ghostSecondary" onclick={onDeny}>Deny</Button>
        <Button variant="primary" onclick={onAllow}>Allow</Button>
      </Dialog.Actions>
    </Dialog.Content>
  </Dialog.Portal>
</Dialog.Root>
